import React, { useEffect } from 'react';
// import PropTypes from 'prop-types';

import {
  LandingHeroStatic,
  LandingHeroVideo,
  LandingHeroCarousel,
  LandingScreeningCTA,
  LandingOverview,
  LandingRequirements,
  LandingInfoBlocks,
  LandingInfoWithPhoto,
  LandingApplicationProcess,
  LandingVideos,
  LandingTotallyCustom,
} from 'bumblebee-ui';
import { useNavigate } from 'react-router-dom';

import { useResetPrescreeningMutation } from '../../redux/reducers/auth';
import { useGetLandingPageQuery } from '../../redux/reducers/config';
import { history } from '../../routers/AppRouter';

const config = stateConfig;

const LandingPage = () => {
  const navigate = useNavigate();

  const  { data: landing_page = {} } = useGetLandingPageQuery();

  const [resetPrescreening, { isLoading }] = useResetPrescreeningMutation();

  useEffect(() => {
    resetPrescreening();
  }, []);

  return (
    <div className='landing-page container-fluid px-0'>
      {/* HERO */}
      {config.landingPage.hero.isStatic && (
        <LandingHeroStatic
          history={history}
          heroSection={config.landingPage.hero.static}
          showButtons={landing_page?.show_buttons} />
      )}

      {config.landingPage.hero.isVideo && (
        <LandingHeroVideo
          history={history}
          heroSection={config.landingPage.hero.video}
          showButtons={landing_page?.show_buttons} />
      )}

      {config.landingPage.hero.isCarousel && (
        <LandingHeroCarousel
          history={history}
          heroSection={config.landingPage.hero.carousel}
          showButtons={landing_page?.show_buttons} />
      )}

      {landing_page?.is_alert_block_visible && (
        <div className='alert-block row px-0 px-md-5'>
          <div className='col-12 col-xxl-10 offset-0 offset-xxl-1 px-5 px-md-0 px-lg-5 py-4'>
            <div dangerouslySetInnerHTML={{ __html: landing_page?.alert_block_content }} />
          </div>
        </div>
      )}

      {/* SECTIONS */}
      {config.landingPage.sections.map((d, i) => {
        switch (d.type) {
          case 'application-process':
            return <LandingApplicationProcess key={i} block={d} onButtonClick={() => navigate('/prescreening')} />;

          case 'info-blocks':
            return <LandingInfoBlocks key={i} block={d} />;

          case 'info-with-photo-left':
            return <LandingInfoWithPhoto key={i} block={d} photoOnLeft />;

          case 'info-with-photo-right':
            return <LandingInfoWithPhoto key={i} block={d} />;

          case 'overview':
            return <LandingOverview key={i} block={d} />;

          case 'requirements':
            return <LandingRequirements key={i} block={d} onButtonClick={() => navigate('/required-documents')} />;

          case 'screening-cta':
            return <LandingScreeningCTA key={i} block={d} onButtonClick={() => navigate('/prescreening')} onLoginClick={() => navigate('/login')} />;

          case 'videos':
            return <LandingVideos key={i} block={d} />;

          case 'totally-custom':
            return <LandingTotallyCustom key={i} block={d} onButtonClick={() => navigate('/required-documents')} />;

          case 'totally-custom-with-link':
            return <LandingTotallyCustom key={i} block={d} onButtonClick={() => navigate(d.buttonLink)} />;
        }
        return false;
      })}
    </div>
  );
};

LandingPage.propTypes = {

};

export default LandingPage;
